// Re-login prompt. The SDK refreshes the OIDC session silently in the
// background; this only appears when that's no longer possible (refresh
// token gone, expired, or revoked) — i.e. when the SDK emits
// `session.expired`. It replaces the old failure mode where a raw
// `cognito-identity ... 400 ... Token expired` string landed in a page's
// error box with no way forward.

import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import { useSession } from "./SessionProvider.tsx";

export function SessionExpiredModal() {
  const { expired, signIn, signOut } = useSession();

  return (
    <Modal
      opened={expired}
      // Not dismissable — there's nothing useful behind it without creds.
      onClose={() => {}}
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      centered
      title="Session expired"
    >
      <Stack gap="md">
        <Text size="sm">
          Your session expired. Sign in again to pick up where you left off.
        </Text>
        <Group justify="flex-end" gap="sm">
          <Button variant="default" onClick={() => signOut()}>
            Sign out
          </Button>
          <Button
            onClick={() => signIn(window.location.pathname + window.location.search)}
          >
            Sign in again
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
